<div class="candidate-welcome" appBlockCopyPaste>
  <app-candidate-header></app-candidate-header>

  <div class="welcome-container">
    <!-- Candidate Info -->
    <app-assessment-info-card [assessmentInfo]="assessmentInfo"></app-assessment-info-card>

    <!-- Welcome Message -->
    <div class="welcome-card">
      <div class="welcome-header">
        <h2>👋 Welcome!</h2>
        <p>Ready to show what you can do?</p>
      </div>

      <div class="welcome-content" (click)="onWelcomeClick($event)"
        [innerHTML]="assessmentInfo?.welcomeTemplate?.content | replaceAll : placeholderDummies"></div>

      <!-- Simple Tips -->
      <div class="tips-box">
        <h3>📝 Quick Tips</h3>
        <ul class="simple-tips">
          <li>Read questions carefully</li>
          <li>Check your internet connection</li>
          <li>Find a quiet place</li>
          <li>Take your time</li>
        </ul>
      </div>

      <!-- Start Button -->
      <div class="start-section">
        <button mat-raised-button color="primary" class="start-btn" (click)="proceedAssessment()">
          Start Assessment
        </button>
        <p class="good-luck">Good luck! 🍀</p>
      </div>
    </div>
  </div>
</div>